import YUSPUtil from '../../../core/util/yusp_util';

import { TypedEvent } from '../../../core/typed_event';
import { JsEnv } from '../../../core/models/js_env';
import { Keyword } from '../models/keyword';
import { AddCartModalAction } from '../../../core/actions/add_cart/modal_action';
import { SuggestionView } from '../views/pc/suggestion/suggestion_views';
import LazyUtil from '../../../core/util/lazy_util';
import { SearchRelatedWordItemRepository } from '../../../core/repositories/search_related_word_item_repository';
import { SuggestionContainer } from '../views/pc/suggestion/suggestion_container';

export class KeywordAction {
  private static state: Keyword;
  private static searchRelatedWordItemRepository: SearchRelatedWordItemRepository;
  static readonly UPDATE_EVENT = new TypedEvent<Keyword>();

  static init(env: JsEnv) {
    this.state = new Keyword(env.PAGE);
    const model = this.state.getModel();
    this.searchRelatedWordItemRepository = new SearchRelatedWordItemRepository();
    new SuggestionContainer(); // NOSONAR

    // サジェッションエリアのもしかしてキーワード表示
    const suggestWordArea = document.getElementById('suggestWordArea') as HTMLInputElement;
    if (suggestWordArea) {
      suggestWordArea.innerHTML = SuggestionView.createSuggestWordArea(model.suggestWordList);
    }

    // ソロアリのヘッダー対応
    const element: HTMLInputElement = <HTMLInputElement>document.getElementById('searchKeywordForHead');
    if (element) {
      element.value = model.searchKeyword.toString();
    }

    // カゴモーダルの初期化
    AddCartModalAction.init();

    // YUSP連携 ユーザーID連携、SEARCHイベント
    YUSPUtil.register({
      enableUserId: true,
      enableSearch: true,
    });
    // YUSPエリアを表示
    YUSPUtil.showYUSPArea({
      enableSearchResult: true,
    })

    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();

    this.addSearchRelatedWordEventListener();
  }


  private static async addSearchRelatedWordEventListener() {
      const relatedWordAnkers = document.querySelectorAll(".searchRelatedWordItems");

      // マウスオーバー時のイベント処理
      const mouseOverEvent = async function (event: Event) {
        const anker = event.currentTarget as HTMLElement;
        const baloonId = anker?.dataset.relatedWordSearchedItemAreaId;
        const isLoadedRelatedWordItemsArea = document.getElementById(baloonId!)?.dataset.relatedwordsearcheditems;


        // 既にAPIが呼び出されていたら、APIを呼ばない
        if (isLoadedRelatedWordItemsArea === 'true') {
          return true;
        }
        if (!baloonId) {
          return true;
        }
        const encryptedSearchWord = anker.getAttribute('id')
        if (!encryptedSearchWord) {
          return true;
        }
        const htmlForRender = await KeywordAction.searchRelatedWordItemRepository.sendRequest(
          encryptedSearchWord
        );

        KeywordAction.state.updateHtmlForRender(htmlForRender);
        KeywordAction.state.updateBaloonId(baloonId);
        KeywordAction.UPDATE_EVENT.trigger(KeywordAction.state);
        const suggestionBaloon = document.getElementById(baloonId)
        if (suggestionBaloon) {
          suggestionBaloon.dataset.relatedwordsearcheditems = "true";
        }

        return true;
      }

      relatedWordAnkers.forEach(relatedWordAnker => {
        // 関連キーワードにマウスオーバーしたときの処理
        relatedWordAnker?.addEventListener('mouseover', (event: Event) => {
          mouseOverEvent(event);
        }, {
          // mouseover複数回実行する（＝同じキーワードに対して商品検索が複数回実行される）のを防ぐために、
          // addEventListenerのオプションにonce: trueを付与する。
          // ハンドラーメソッドが1回実行されたら、リスナーが削除されます。
          'once': true
        })
      })
    }
}
